module.exports = __webpack_public_path__ + "static/media/aircraft-cargo-freight-air-logistics.4e21bf3b.jpg";